import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-cpmAudioTypeShape",
  "use": "svg-icon-cpmAudioTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-cpmAudioTypeShape\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.213.699l-1.494 1.329A8.982 8.982 0 0 1 13.999 8a8.98 8.98 0 0 1-2.28 5.972l1.494 1.33A10.983 10.983 0 0 0 16 8c0-2.687-.99-5.28-2.787-7.301zm-2.986 2.654l-1.494 1.33A4.99 4.99 0 0 1 10 8c0 1.22-.45 2.399-1.267 3.318l1.494 1.329A6.982 6.982 0 0 0 12 8a6.981 6.981 0 0 0-1.773-4.647zM0 6h2.894l3.845-4h.26v12h-.26l-3.841-4H0V6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol